<template>
  <account-listing />
</template>
<script>
import AccountListing from '@/components/wasabi/AccountListing.vue'
export default {
  name: 'WasabiView',
  components: {
    AccountListing
  }
}
</script>
<style lang="scss" scoped></style>
